import classNames from "classnames";
import style from "./pickers.module.css";
import * as Select from "frontend/ui-components/select/select";

export const ColumnPicker = ({
  selected,
  setSelected,
  options,
  placeholder = "Search for a field",
  testId,
  theme = "light",
}: {
  selected: string;
  setSelected: (id: string) => void;
  placeholder?: string;
  options?: { id: string; title: string }[];
  testId: string;
  theme?: "light" | "dark";
}) => {
  const hasOptions = !!options && options.length > 0;
  const selectedLabel = hasOptions && options.find((option) => option.id === selected)?.title;
  const usePlaceholder = !selectedLabel;
  // eslint-disable-next-line unicorn/no-negated-condition
  const label = !hasOptions ? "No options" : usePlaceholder ? placeholder : selectedLabel;

  return (
    <Select.Select selectedId={selected} setSelectedId={setSelected} allowOpenOptions={hasOptions}>
      <Select.Trigger rounded={true} customClass={classNames(style.selectTrigger, style[theme])}>
        <div
          title={label}
          style={{ display: "inline-block", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}
          data-testid={`${testId}-trigger`}
        >
          {label}
        </div>
        <Select.Arrow theme={theme} />
      </Select.Trigger>
      <Select.Popover className={classNames(style.background, style.popover, style.rounded, style[theme])}>
        <Select.OptionsList>
          <div className={style.popoverChildren}>
            {options?.map(({ id, title }) => (
              <Select.Option id={id} key={id}>
                <div
                  title={title}
                  data-testid={`${testId}-option-${id}`}
                  className={classNames(style.boardPickerOption, selected == id && style.selected)}
                >
                  {title}
                </div>
              </Select.Option>
            ))}
          </div>
        </Select.OptionsList>
      </Select.Popover>
    </Select.Select>
  );
};
